import moment from 'moment'

export class MContactMessage {
    category: any

    description: string

    email: string

    id: string

    isFAQ: number

    madeAt: string

    status: 'ACTIVE'

    title: string

    topic: any

    type: string

    userId: string

    user: string

    constructor(message: MContactMessage) {
        this.category = message?.category?.code
        this.description = message?.description
        this.email = message?.email
        this.id = message?.id
        this.isFAQ = message?.isFAQ
        this.madeAt = message?.madeAt
            ? moment(message?.madeAt).format('DD/MM/YY')
            : ' - '
        this.status = message?.status
        this.title = message?.title || ' - '
        this.topic = message?.topic?.code
        this.type = message?.type
        this.userId = message?.userId
        this.user = message?.type === 'ANSWER' ? 'Admin' : 'User'
    }
}
